// Third-party imports
import $ from 'jquery';
import _ from 'lodash';
import Cookie from 'js-cookie';
import '@accessible360/accessible-slick';
import { getCartProducts } from '../gift_catalogue/logic/cart.js';

// Module name
export const MODULE_NAME = 'recently_viewed';

export let global_vars = {};

// Called directly after the API call is complete to ensure that the slider is initialzed at the correct time
function recentlyViewedSlider() {
    let slickElement = $('.js-recentProducts-hook');
    slickElement.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
    });
}

export function initialize(global) {
    let productHandle = $('.js-productHandleForCookie-hook').data(
        'producthandle'
    );
    if (productHandle) {
        productHandle = String(productHandle);
        recentlyViewedItemsHandler(global, productHandle);
    }
}

function recentlyViewedItemsHandler(global, productHandle) {
    let cookieKey = 'WV_Recently_Viewed';
    let cookiesString = getCookie(cookieKey);
    let cookiesArrayFromBrowser = browserCookiesArrayHandler(
        cookiesString,
        productHandle
    );
    productAPIRequestHandler(cookiesArrayFromBrowser, productHandle);
    let cookiesArrayToSetCookies = addCurrentProductToCookieArray(
        productHandle,
        cookiesArrayFromBrowser
    );
    buildNewCookieString(
        global,
        cookieKey,
        cookiesArrayToSetCookies,
        productHandle
    );
}

//
// Functions that handle the API requests
//

function productAPIRequestHandler(cookiesArray, productHandle) {
    let requestString = buildRequestIDsString(cookiesArray);
    makeProductAPIRequest(requestString, cookiesArray, productHandle);
}

function buildRequestIDsString(cookiesArray) {
    let requestString = '';
    cookiesArray.forEach((element, index) => {
        if (index + 1 !== cookiesArray.length) {
            requestString += element + ',';
        } else {
            requestString += element;
        }
    });
    return requestString;
}

function makeProductAPIRequest(requestString, cookiesArray, productHandle) {
    let APIEndPoint = `/admin/products.json?ids=${requestString}`;
    let productsArray = [];
    $.get(APIEndPoint)
        .then(data => {
            if (!('products' in data)) {
                let msg =
                    'Resource did not return proper json data: ' +
                    `${APIEndPoint}`;
                throw new TypeError(msg);
            }
            productsArray = data.products;
            productsArray = reorderingProductArray(productsArray, cookiesArray);
            let htmlProductsCards = buildHtmlCardsHandler(
                productsArray,
                productHandle
            );
            checkIfProductCardsAndDispatch(htmlProductsCards);
        })
        .catch(() => {
            hideRecentlyViewedArea();
        });
}

function reorderingProductArray(productsArray, cookiesArray) {
    let reorderedArray = [];
    for (let x = 0; x < cookiesArray.length; x++) {
        productsArray.forEach(product => {
            let productId = String(product.id);
            if (cookiesArray[x] === productId) {
                reorderedArray.push(product);
            }
        });
    }
    return reorderedArray;
}

function buildHtmlCardsHandler(productsArray, productHandle) {
    let htmlProductsCards = [];
    let productCard = '';
    let hasProductsToShow = false;
    for (let x = 0; x < productsArray.length; x++) {
        if (String(productsArray[x].id) !== productHandle) {
            let currentProduct = productsArray[x];
            productCard = htmlFullCard(currentProduct, x);
            hasProductsToShow = true;
            htmlProductsCards.push(productCard);
        }
    }
    //let numberOfEmptyCards = totalNumberOfCards - availableCards;
    let numberOfEmptyCards = 0;
    emptyCardsHandler(numberOfEmptyCards, productCard, htmlProductsCards);
    return hasProducts(hasProductsToShow, htmlProductsCards);
}

function hasProducts(hasProductsToShow, htmlProductsCards) {
    if (hasProductsToShow) {
        return htmlProductsCards;
    } else {
        return false;
    }
}

function htmlFullCard(currentProduct, index) {
    let productImageUrl = currentProduct.image.src;
    let productImageAlt = currentProduct.image.alt;
    let productId = currentProduct.id;
    let productName = currentProduct.title;
    let cardid = 'cardid' + index;

    let productOptions = currentProduct.options;
    let productVariants = currentProduct.variants;
    let productPrice = productVariants[0].price;
    let productUrl = `/products/${currentProduct.handle}`;
    let fullProductCard = `<div class="grid-1of4 grid-1of2--lap grid-1of1--phablet" style="padding-left: 20px;">
        <div id="${cardid}"
            class="product-card card--tabbedproduct"
            data-cardnum="cardid${index}">
            <div class="product-card-img-wrapper">
                <img
                    src="${productImageUrl}"
                    alt="${productImageAlt}"
                    class="product-card-img"
                />
            </div>
            <div class="product-card-body product-card-body--grow product-card-bg">
                <div class="product-card-header product-card-header--grow">
                    <a href="${productUrl}">
                        <h3
                            class="product-card-title"
                        >
                            ${productName}
                                <img src="{{ 'icon_headline_arrow.svg' | asset_url }}" alt="" aria-hidden="true" class="product-card-icon">
                        </h3>
                    </a>
                    <input id="dataid${index}"
                        type="hidden"
                        data-price="${productPrice}"
                        data-id="${productId}"
                        data-name="${productName}"
                        data-brand="One Time Donation"
                        data-variant=""
                        data-category=""
                        data-productList="Recently Viewed Products List" />
                    <div class="product-card-img-options">`;
    for (let i = 0; i < productOptions.length; i++) {
        //let optionNamePretty = productOptions[i].name;
        //let optionNameKebab = productOptions[i].name.replace(' ', '-');
        if (
            !productOptions[i].name.includes('Sizes') &&
            !productOptions[i].name.includes('Colours')
        ) {
            if (i === 0) {
                fullProductCard =
                    fullProductCard +
                    `<form id="form${index}"
                    method="post"
                    enctype="multipart/form-data"
                    class="js-validate"
                    >
                        <div>
                            <div>`;
                let already_in_cart = false;
                let quantity_in_cart = 0;
                let productsInCartArray = [];
                getCartProducts(productVariants, productsInCartArray);
                if (
                    !productOptions[i].name.includes('Sizes') &&
                    !productOptions[i].name.includes('Colours')
                ) {
                    fullProductCard =
                        fullProductCard +
                        `<div class="field">
                            <label for="variantid${index}" class="u-accessible">${productName}</label>
                            <select id="variantid${index}" class="field-input field-input--grey js-variantOptions-hook">`;

                    for (let j = 0; j < productVariants.length; j++) {
                        //todo format price {% include 'datalayer-price', preformatted_price: variant.price %}
                        let preformatted_price = productVariants[j].price;
                        // for (let k = 0; productsInCartArray.length - 1; k++) {
                        //     console.log(productsInCartArray);
                        //     if (productsInCartArray[k].variant_id) {
                        //         if (
                        //             productsInCartArray[k].variant_id ===
                        //             productVariants[j].variantid
                        //         ) {
                        //             already_in_cart = true;
                        //             quantity_in_cart = productsInCartArray[k].quantity;
                        //         }
                        //     }
                        // }
                        fullProductCard =
                            fullProductCard +
                            `<option
                            data-price="${preformatted_price}"
                            data-gift-id-sku="${productVariants[j].sku}"
                            data-in-cart="${already_in_cart}"
                            data-cart-quantity="${quantity_in_cart}"
                            >
                                ${preformatted_price}
                            </option>`;
                    }
                    fullProductCard =
                        fullProductCard +
                        `</select>
                        </div>`;
                } else {
                    //todo format price % include 'datalayer-price', preformatted_price: variant.price %}
                    //{% assign _price = product.price | money_without_trailing_zeros %}
                    //{% include 'amount' with _price, excludeDollarSign: true %}
                    fullProductCard =
                        fullProductCard +
                        `<span class="card--imageStakedCardTertiary-price">
                            ${productPrice}
                        </span>`;
                }
                // for (let k = 0; productsInCartArray.length - 1; k++) {
                //     console.log(productsInCartArray);
                //     if (productsInCartArray[k].variant_id) {
                //         if (
                //             productsInCartArray[k].variant_id ===
                //             productID
                //         ) {
                //             already_in_cart = true;
                //             quantity_in_cart = productsInCartArray[k].quantity;
                //         }
                //     }
                // }
                //todo                             {% include 'gc-product-lineitem', product: product %}

                fullProductCard =
                    fullProductCard +
                    `</div>
                        <div>
                            <input
                                type="hidden"
                                id="productIDHook${index}"
                                name="id"
                                value="${productId}"
                                data-in-cart="${already_in_cart}"
                                data-cart-quantity="${quantity_in_cart}"
                                data-add-label="add"
                                data-already-in-cart-label="add"
                                required
                            />
                            <button id="buttonid${index}"
                                class="button u-wideWidth product-card-button-spacing"
                                name="add"
                                type="submit"
                                role="button"
                                tabindex="0"
                                aria-label="Add"
                            >
                                <div class="spinner spinner--white spinner--small spinner--button u-hide" id="addButtonSpinner${index}"></div>
                                <div id="addButtonLabel${index}">Add</div>
                            </button>
                        </div> 
                    </div>
                </form>`;
            }
        } else {
            if (i === 0) {
                fullProductCard =
                    fullProductCard +
                    `<div class="combo combo--rev combo--middle combo--stack--portable">
                        <div class="combo-first">
                            <span class="card--imageStakedCardTertiary-price">
                                {% assign _price = product.price | money_without_trailing_zeros %}
                                {% include 'amount' with _price, excludeDollarSign: true %}
                                {{ formattedAmount }}
                            </span>
                        </div>
                        <div class="combo-last">
                            <a href="${productUrl}" class="button button--small card--imageStakedCardTertiary-submit">{{ s.buttonText_shopThisItem }}</a>
                        </div>
                    </div>`;
            }
        }
    }
    fullProductCard =
        fullProductCard +
        `<a id="{{ viewbuttonid }}" class="viewInCart button u-wideWidth product-card-button-spacing button--removed" aria-label="{{ s.buttonText_viewInBasket }}" aria-live="polite" role="link" href="/cart">
                        {{ s.buttonText_viewInBasket }}
                    </a>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
    return fullProductCard;
}

function emptyCardsHandler(numberOfEmptyCards, productCard, htmlProductsCards) {
    for (let i = 0; i < numberOfEmptyCards; i++) {
        productCard = htmlEmptyCard();
        htmlProductsCards.push(productCard);
    }
}

function htmlEmptyCard() {
    let emptyCard = `<div class="card card--imageCard card--imageCardSecondary card--imageCardTop card--blank">
    <a class="card-image"></a>
    <div>
      <div class="card-textWrapper u-alignLeft">
      </div>
    </div>
  </div>`;
    return emptyCard;
}

function checkIfProductCardsAndDispatch(htmlProductsCards) {
    if (htmlProductsCards) {
        injectHTMLProducts(htmlProductsCards);
    } else {
        hideRecentlyViewedArea();
    }
}

function hideRecentlyViewedArea() {
    $('.js-recentlyViewedWrapper-hook').addClass('u-hide');
}

function injectHTMLProducts(htmlProductsCards) {
    let count = 0;
    let target = $('.js-recentProducts-hook');
    htmlProductsCards.forEach(function(card) {
        count++;
        $(target).append(card);
    });
    if (count > 4) recentlyViewedSlider();
}

//
// Functions that handle the cookies
//

function getCookie(name) {
    return Cookie.get(name);
}

function browserCookiesArrayHandler(cookiesString, productHandle) {
    let cookiesArray;
    if (cookiesString) {
        cookiesArray = buildBrowserCookieArray(cookiesString, productHandle);
    } else {
        cookiesArray = [String(productHandle)];
    }
    return cookiesArray;
}

function buildBrowserCookieArray(cookies) {
    let cookiesArray = cookies.split('+');
    cookiesArray = _.uniq(cookiesArray);
    cookiesArray = popWhenArrayTooLong(cookiesArray);
    return cookiesArray;
}

function addCurrentProductToCookieArray(productHandle, cookiesArray) {
    if (productHandle) {
        let newCookieArray = cookiesArray.slice();
        newCookieArray.unshift(productHandle);
        newCookieArray = _.uniq(newCookieArray);
        return newCookieArray;
    } else {
        return cookiesArray;
    }
}

function popWhenArrayTooLong(cookiesArray) {
    if (cookiesArray.length > 8) {
        cookiesArray.pop();
    }
    return cookiesArray;
}

function buildNewCookieString(global, cookieKey, cookiesArray, productHandle) {
    let cookieString = `${cookieKey}=`;
    for (let x = 0; x < cookiesArray.length; x++) {
        if (x === 0) {
            cookieString = `${cookieString}${cookiesArray[x]}`;
        } else {
            cookieString = `${cookieString}+${cookiesArray[x]}`;
        }
    }
    injectCookies(global, cookieString, productHandle);
}

// global arg is expected to be the window object when run in a browser
function injectCookies(global, newCookie, productHandle) {
    if (productHandle) {
        global.document.cookie = newCookie;
    }
}
